import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { Image } from 'app/components/image';
import { breakpointTablet } from 'app/style/breakpoints';
import { spacing1, spacing2, spacing3, spacing4 } from 'app/style/spacing';

export const StyledDescription = styled(Typography)`
    margin-bottom: ${spacing4};
`;

export const StyledTitle = styled(Typography)`
    font-weight: bold;
    margin-bottom: ${spacing1};

    @media (min-width: ${breakpointTablet}) {
        margin-bottom: ${spacing2};
    }
`;

export const StyledContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: ${spacing2};

    @media (min-width: ${breakpointTablet}) {
        display: block;
    }
`;

export const StyledSingleMeshUnitImage = styled(Image)`
    max-width: 46px;
    display: block;
    margin: ${spacing1} ${spacing3} 0 ${spacing1};

    @media (min-width: ${breakpointTablet}) {
        max-width: 73px;
        margin: 0 auto ${spacing3};
    }
`;
